import { Parallax } from 'react-parallax';
import HeroImg from '../assets/about_hero.jpg'
import { useEffect, useState } from "react";
import { fetchPageContent } from "../api/contentApi";
import { useLang } from "../context/LangContext";
import "../styles/main_hero.css";


const HeroSection = () => {
  const [content, setContent] = useState({});
  const { lang } = useLang();

  useEffect(() => {
    fetchPageContent("about", lang).then(data => setContent(data));
  }, [lang]);
  
  return (
    <Parallax 
    blur={1.5} 
    bgImage={HeroImg} 
    bgImageAlt="hero img" 
    strength={600}
    className="hero-img"
    >
    
    <span className="hero-content" >
    {content.about_title && (  
   <p className="about-hero-text">{content.about_title}</p>
    )}  
    {content.about_subtitle && ( 
   <p className="about-hero-subtext">{content.about_subtitle}</p>
    )}  

    </span>
    </Parallax>
  );
}
export default HeroSection;